import type {
  AccentsType,
  IAppearancePreferences,
  IWaitingAnimationPreferences,
  WaitingChoiceType,
} from '@featit/shared';
import { ApiService } from './ApiService';

/** F-0579 ACC-1: the person's *Accents* on the server. The caller's own setting only. */
class AppearanceApiService extends ApiService {
  appearance(): Promise<IAppearancePreferences> {
    return this.get('/user-preferences/appearance');
  }

  updateAppearance(accents: AccentsType): Promise<IAppearancePreferences> {
    return this.patch('/user-preferences/appearance', { accents });
  }
}

export const appearanceApi = new AppearanceApiService();

/** F-0578 WAIT-5: the person's *Waiting animation* on the server. The caller's own setting only. */
class WaitingAnimationApiService extends ApiService {
  waitingAnimation(): Promise<IWaitingAnimationPreferences> {
    return this.get('/user-preferences/waiting-animation');
  }

  updateWaitingAnimation(study: WaitingChoiceType): Promise<IWaitingAnimationPreferences> {
    return this.patch('/user-preferences/waiting-animation', { study });
  }
}

export const waitingAnimationApi = new WaitingAnimationApiService();
